export const PRICING_PLAN = {
    PLAN_SELECTED_DESCRIPTION: {
        key: 'PLAN_SELECTED_DESCRIPTION',
        value: 'PLAN SELECTED'
    }
};